document.addEventListener("DOMContentLoaded", function () {
    window.themeManager = new ThemeManager({
        themes: ["default", "dark"],
        defaultTheme: "default",
        storageKeyTheme: "rt-theme",
        storageKeyInitialised: "rt-theme-initialised"
    });
});
